<template>
  <div class="chunyu-kangle-page">
    <div id="navbar" class="navbar">
      <div class="navbar-main">
        <a href="https://www.chunyukl.cn/" class="logo-wrapper">
          <img
            src="https://staff.chunyu.mobi/@/media/images/2024/03/15/131a/41bf37db4a3c_w627_h111_.png"
            class="logo-img"
            alt="logo"
          />
          <div class="logo-text">春雨康乐</div>
        </a>
        <div class="action-wrapper">
          <a
            href="https://kl-cdn.chunyuyisheng.cn/rep/apk/app3.6.1.apk"
            target="_blank"
            class="android-download"
          >
            <img
              src="https://staff.chunyu.mobi/@/media/images/2024/03/15/c92f/af083ae84231_w231_h57_.png"
              alt="安卓下载"
            />
          </a>
          <a id="nav-qrcode-btn" href="javascript:void(0);">
            <div class="qrcode-download">
              <img
                src="https://staff.chunyu.mobi/@/media/images/2024/03/15/2483/d394fc49cff0_w90_h45_.png"
                alt="手机扫二维码下载"
              />
              <div id="nav-qrcode-hover" class="qrcode-hover-wrapper">
                <div class="qrcode-hover-img">
                  <img
                    src="https://staff.chunyu.mobi/@/media/images/2024/03/15/4e30/43aa2cb55e8b_w400_h400_.png"
                    alt="二维码"
                  />
                </div>
                <div class="qrcode-hover-text">手机扫二维码下载</div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <main class="main-content-wrapper">
      <section class="page-section section0">
        <div class="title">
          <img
            src="https://staff.chunyu.mobi/@/media/images/2024/03/15/2e27/a4e1632f2fc5_w1164_h435_.png"
            alt="春雨康乐极速版"
          />
        </div>
        <div class="download-wrapper">
          <a
            href="https://kl-cdn.chunyuyisheng.cn/rep/apk/app3.6.1.apk"
            target="_blank"
            class="android-btn"
            alt="立即下载"
          >
            <img
              src="https://staff.chunyu.mobi/@/media/images/2024/03/15/06ce/e93b24be4df2_w648_h147_.png"
              alt="立即下载"
            />
          </a>
          <a href="javascript:void(0);" class="qrcode-btn">
            <div id="section-qrcode-btn" class="qrcode-download-btn">
              <img
                class="qrcode-img-btn"
                src="https://staff.chunyu.mobi/@/media/images/2024/03/15/0860/4074174648b4_w44_h44_.png"
                alt="手机扫二维码下载"
              />
              <div id="section-qrcode-hover" class="qrcode-hover-wrapper">
                <img
                  src="https://staff.chunyu.mobi/@/media/images/2024/03/15/4e30/43aa2cb55e8b_w400_h400_.png"
                  alt="二维码"
                />
              </div>
            </div>
          </a>
        </div>
      </section>
      <section id="main-section1" class="page-section section1">
        <div class="section-main">
          <div class="section-left-wrapper">
            <img
              src="https://staff.chunyu.mobi/@/media/images/2024/03/15/3f2f/a2f98a7af6a0_w750_h1624_.jpg"
              alt="多维度文章阅读"
            />
          </div>
          <div class="section-right-wrapper">
            <div class="section-title">多维度文章阅读</div>
            <ul class="section-subtitle">
              <li class="subtitle-item">全网优质健康科普内容</li>
              <li class="subtitle-item">顶尖大数据推荐算法</li>
            </ul>
            <div class="section-icon">
              <div class="icon-item">
                <img
                  src="https://staff.chunyu.mobi/@/media/images/2024/03/15/8231/c0874ba2d5cf_w86_h86_.png"
                  alt="icon"
                />
                <div class="icon-text">权威内容</div>
              </div>
              <div class="icon-item">
                <img
                  src="https://staff.chunyu.mobi/@/media/images/2024/03/15/9435/1fc898e9929b_w86_h86_.png"
                  alt="icon"
                />
                <div class="icon-text">大数据算法</div>
              </div>
              <div class="icon-item">
                <img
                  src="https://staff.chunyu.mobi/@/media/images/2024/03/15/8e5d/e4aa2ee34d3c_w86_h86_.png"
                  alt="icon"
                />
                <div class="icon-text">个性化推荐</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="page-section section2">
        <div class="section-main">
          <div class="section-left-wrapper">
            <img
              src="https://staff.chunyu.mobi/@/media/images/2024/03/15/254b/6aa0037456a0_w750_h1701_.jpg"
              alt="丰富福利活动"
            />
          </div>
          <div class="section-right-wrapper">
            <div class="section-title">丰富福利活动</div>
            <ul class="section-subtitle">
              <li class="subtitle-item">定期开展福利兑换活动</li>
              <li class="subtitle-item">奖品多多，极速发货</li>
            </ul>
            <div class="section-icon">
              <div class="icon-item">
                <img
                  src="https://staff.chunyu.mobi/@/media/images/2024/03/15/4d5b/f841444be536_w86_h86_.png"
                  alt="icon"
                />
                <div class="icon-text">多维度活动</div>
              </div>
              <div class="icon-item">
                <img
                  src="https://staff.chunyu.mobi/@/media/images/2024/03/15/cf85/fae812adae47_w86_h86_.png"
                  alt="icon"
                />
                <div class="icon-text">长期福利</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="page-section section3">
        <div class="section-main">
          <div class="section-left-wrapper">
            <img
              src="https://staff.chunyu.mobi/@/media/images/2024/03/15/91e1/a2f5de270ffd_w750_h1624_.png"
              alt="轻松月入千元零钱"
            />
          </div>
          <div class="section-right-wrapper">
            <div class="section-title">轻松月入千元零钱</div>
            <ul class="section-subtitle">
              <li class="subtitle-item">邀请好友看新闻，每月轻松赚千元</li>
              <li class="subtitle-item">收入提现秒到账</li>
            </ul>
            <div class="section-icon">
              <div class="icon-item">
                <img
                  src="https://staff.chunyu.mobi/@/media/images/2024/03/15/2032/e68e156efc52_w86_h86_.png"
                  alt="icon"
                />
                <div class="icon-text">每天领零钱</div>
              </div>
              <div class="icon-item">
                <img
                  src="https://staff.chunyu.mobi/@/media/images/2024/03/15/9a4d/5df17593acb4_w86_h86_.png"
                  alt="icon"
                />
                <div class="icon-text">多任务并行</div>
              </div>
              <div class="icon-item">
                <img
                  src="https://staff.chunyu.mobi/@/media/images/2024/03/15/88e0/73c2f1e3c9d2_w86_h86_.png"
                  alt="icon"
                />
                <div class="icon-text">丰富礼品兑换</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <div class="page-footer">
      <div class="footer-nav">
        <a
          href="https://kl-api.chunyuyisheng.cn/contract.html"
          class="footer-nav-item"
          >用户协议</a
        >
        <a
          href="https://kl-api.chunyuyisheng.cn/privacy_policy.html"
          class="footer-nav-item"
          >隐私政策</a
        >
      </div>
      <div class="footer-info">
        <p>Copyright © 2023-2024 北京康乐慧科技有限公司 All Rights Reserved</p>
        <p>京ICP备2023012620号 京ICP备2023012620号-1</p>
        <p>违法和不良信息举报：feedback@chunyu.me</p>
        <p>联系我们：400-001-8855</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'KangLe',
  mounted() {
    this.changeSectionQrcodeVisible();
    this.changeNavbarVisible();
    this.changeNavbarQrcodeVisible();
  },
  methods: {
    changeNavbarVisible() {
      // eslint-disable-next-line no-var
      var stickyDom = document.querySelector('#main-section1');
      // eslint-disable-next-line no-var
      var navbarDom = document.querySelector('.navbar');
      if (stickyDom && navbarDom) {
        window.addEventListener('scroll', function() {
          // eslint-disable-next-line no-var
          var stickyDomTop = stickyDom.getBoundingClientRect().top;
          if (stickyDomTop <= 0) {
            navbarDom.classList.add('show');
          } else {
            navbarDom.classList.remove('show');
          }
        });
      }
    },
    changeNavbarQrcodeVisible() {
      // eslint-disable-next-line no-var
      var navQrcodeBtn = document.querySelector('#nav-qrcode-btn');
      // eslint-disable-next-line no-var
      var navQrcodeHover = document.querySelector('#nav-qrcode-hover');
      this.changeDomVisibelByHover(navQrcodeBtn, navQrcodeHover);
    },
    changeSectionQrcodeVisible() {
      // eslint-disable-next-line no-var
      var sectionQrcodeBtn = document.querySelector('#section-qrcode-btn');
      // eslint-disable-next-line no-var
      var sectionQrcodeHover = document.querySelector('#section-qrcode-hover');
      this.changeDomVisibelByHover(sectionQrcodeBtn, sectionQrcodeHover);
    },
    changeDomVisibelByHover(hoverDom, visibleDom) {
      if (hoverDom && visibleDom) {
        hoverDom.addEventListener('mouseover', function() {
          visibleDom.classList.add('show');
        });
        hoverDom.addEventListener('mouseout', function() {
          visibleDom.classList.remove('show');
        });
      }
    },
  },
};
</script>
<style>
img {
  display: block;
  width: 100%;
  height: 100%;
}

.chunyu-kangle-page {
  min-width: 1000px;
  background-color: #fff;
}

.navbar {
  position: fixed;
  left: 0;
  display: none;
  width: 100%;
  height: 80px;
  background-color: #fff;
  box-shadow: 0 0 5px #dcdcdc;
}
.navbar.show {
  display: block;
}

.navbar-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1000px;
  height: 80px;
  margin: 0 auto;
}

.navbar-main .logo-wrapper {
  width: 209px;
  height: 37px;
  overflow: hidden;
}

.navbar-main .action-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.action-wrapper .android-download {
  width: 77px;
  height: 19px;
  margin-right: 14px;
  overflow: hidden;
}

.action-wrapper .android-download:hover {
  border-bottom: 1px solid #49bd97;
}

.action-wrapper .qrcode-download {
  position: relative;
  width: 30px;
  height: 15px;
}

.qrcode-download .qrcode-hover-wrapper {
  position: absolute;
  top: 30px;
  left: -70px;
  display: none;
  width: 170px;
}
.qrcode-download .qrcode-hover-wrapper.show {
  display: block;
}
.qrcode-download .qrcode-hover-wrapper .qrcode-hover-img {
  width: 140px;
  height: 140px;
  margin: 0 auto;
}
.qrcode-download .qrcode-hover-wrapper .qrcode-hover-text {
  margin-top: 10px;
  color: #666;
  font-size: 14px;
  text-align: center;
}

.page-section.section0 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 600px;
  background-image: url('https://staff.chunyu.mobi/@/media/images/2024/03/15/0655/6363ce3174a7_w1000_h517_.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.page-section.section1 {
  background-image: url('https://staff.chunyu.mobi/@/media/images/2024/03/15/d2d9/fbfa129c5abf_w1671_h926_.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.page-section.section2 {
  background-image: url('https://staff.chunyu.mobi/@/media/images/2024/03/15/5d0c/59c338a3eb68_w1649_h796_.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.page-section .section-main {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1000px;
  margin: 0 auto;
  padding: 50px 0;
}

.section0 .title {
  width: 388px;
  height: 145px;
}

.section0 .download-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 37px;
}

.download-wrapper .android-btn {
  width: 216px;
  height: 49px;
  overflow: hidden;
}

.download-wrapper .android-btn:hover {
  box-shadow: 0 0 10px #dcdcdc;
}

.download-wrapper .qrcode-download-btn {
  position: relative;
  width: 22px;
  height: 22px;
  margin-left: 26px;
}

.download-wrapper .qrcode-download-btn .qrcode-hover-wrapper {
  position: absolute;
  top: -49px;
  left: 40px;
  display: none;
  width: 120px;
  height: 120px;
  background-color: #dcdcdc;
}

.download-wrapper .qrcode-download-btn .qrcode-hover-wrapper.show {
  display: block;
}

.download-wrapper .qrcode-download-btn .qrcode-hover-wrapper::before {
  position: absolute;
  top: 50%;
  left: -8px;
  border-color: transparent #dcdcdc transparent transparent; /* 箭头颜色和透明边 */
  border-style: solid;
  border-width: 5px 8px 5px 0;
  transform: translateY(-50%);
  content: '';
}

.download-wrapper .qrcode-download-btn .qrcode-hover-wrapper img {
  position: relative;
  display: block;
  width: 110px;
  height: 110px;
  margin: 5px;
}

.section-main .section-left-wrapper {
  width: 375px;
  height: 667px;
  margin-right: 50px;
  overflow: hidden;
  box-shadow: 0 0 10px #dcdcdc;
}

.section-main .section-right-wrapper {
  margin-left: 50px;
}
.section-right-wrapper .section-title {
  color: #545454;
  font-weight: bold;
  font-size: 50px;
}
.section-right-wrapper .section-subtitle {
  margin: 20px 0 50px 0;
}
.section-right-wrapper .section-subtitle .subtitle-item {
  color: #2d2d2d;
  font-size: 20px;
  line-height: 1.5;
  list-style: circle inside;
}

.section-right-wrapper .section-icon {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.section-right-wrapper .section-icon .icon-item {
  margin: 0 17px;
}
.section-right-wrapper .section-icon .icon-item img {
  display: block;
  width: 86px;
  height: 86px;
  margin: 0 auto 17px auto;
}
.section-right-wrapper .section-icon .icon-item .icon-text {
  color: #666;
  font-size: 14px;
  text-align: center;
}

.page-footer {
  margin-top: 50px;
  padding: 20px 0;
  box-shadow: 0 0 5px #dcdcdc;
}
.page-footer .footer-nav {
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-nav .footer-nav-item {
  padding: 0 22px;
  color: #666;
  font-size: 16px;
}
.footer-nav .footer-nav-item:visited {
  color: #666;
}
.footer-nav .footer-nav-item:active {
  color: #666;
}
.footer-nav .footer-nav-item:hover {
  color: #666;
}
.footer-info {
  margin-top: 20px;
}
.footer-info p {
  margin: 0;
  color: #666;
  font-size: 12px;
  line-height: 1.5;
  text-align: center;
}
</style>
